import { SelectOption } from '@globaleris/ui.library'
import moment from 'moment'
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import {
  MassiveDispatchRequest,
  TankIdValue,
  FetchTankOpsToDispatchRequest,
  DefaultCosts
} from '../../../../pages/tanks/tanks.model'
import {
  getActiveBalanceZone,
  getActiveCompany,
  getAppConfigurationValue,
  getUserId,
  getActiveUser
} from '../../../../redux'
import AxiosInstance from '../../../http-config'
import { EnumDispatchType } from '../../../oData'
import Tanks from '../../model/Tanks'
import { EnumEstadoViajeOpLogistica } from '../../../oData/enums/enumEstadoViajeOpLogistica'

export const apiTanksGET = async (
  startDate?: Date,
  endDate?: Date,
  clientId?: number
): Promise<Tanks[]> => {
  const company = getActiveCompany()?.id
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeUserId = getActiveUser().id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const initRange = moment(startDate).format('YYYY-MM-DD')
  const endRange = moment(endDate).format('YYYY-MM-DD')

  let query = `startDate=${initRange}&endDate=${endRange}&companyId=${company}&balanceZoneId=${activeBalanceZone}&userId=${activeUserId}`

  //69306 - Como ahora se pueden relacionar varios sujetos con un usuario, vamos a pasar el UserId para buscar los sujetos relacionados en Pioneer.
  //Si no hay ningún registro en la tabla EVG_T_R_USER_CLIENTE_GNL, se asume que tiene que devolver todos
  //if (clientId) {
  //  query = query + `&subjectId=${clientId}`
  //}

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tanks/FetchTanks?${query}`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTanksLastHundredGET = async (
  clientId?: number
): Promise<Tanks[]> => {
  const company = getActiveCompany()?.id
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeUserId = getActiveUser().id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  let query = `companyId=${company}&balanceZoneId=${activeBalanceZone}&userId=${activeUserId}`

  //69306 - Como ahora se pueden relacionar varios sujetos con un usuario, vamos a pasar el UserId para buscar los sujetos relacionados en Pioneer.
  //Si no hay ningún registro en la tabla EVG_T_R_USER_CLIENTE_GNL, se asume que tiene que devolver todos
  //if (clientId) {
  //  query = query + `&subjectId=${clientId}`
  //}

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tanks/FetchTanksLastHundreds?${query}`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTanksGETByManagedState = async (
  managedTripState: EnumEstadoViajeOpLogistica
): Promise<Tanks[]> => {
  const company = getActiveCompany()?.id
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeUserId = getActiveUser().id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  //69306 - Como ahora se pueden relacionar varios sujetos con un usuario, vamos a pasar el UserId para buscar los sujetos relacionados en Pioneer.
  //Si no hay ningún registro en la tabla EVG_T_R_USER_CLIENTE_GNL, se asume que tiene que devolver todos
  let query = `managedTripState=${managedTripState}&companyId=${company}&balanceZoneId=${activeBalanceZone}&userId=${activeUserId}`

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Tanks/FetchTanksByManagedState?${query}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTanksForUserGET = async ({
  startDate,
  endDate,
  lastHundredTanks
}: {
  startDate?: Date
  endDate?: Date
  lastHundredTanks?: boolean | null
}): Promise<Tanks[]> => {
  const company = getActiveCompany()?.id
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeUserId = getActiveUser().id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const initRange = moment(startDate).format('YYYY-MM-DD')
  const endRange = moment(endDate).format('YYYY-MM-DD')

  let query = `startDate=${initRange}&endDate=${endRange}&userId=${activeUserId}&companyId=${company}&balanceZoneId=${activeBalanceZone}`

  if (lastHundredTanks) {
    query = query + `&lastHundreds=${lastHundredTanks}`
  }

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tanks/FetchTanksForUser?${query}`).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      } else {
        return []
      }
    }
  )
}

export const apiTanksAdd = async (tank: any): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Tanks/CreateTank`, tank).then(res => {
    return true
  })
}

export const apifetchCarriers = async (): Promise<Array<any>> => {
  const activeBalanceZone = getActiveBalanceZone()?.id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Tanks/FetchCarriers?balanceZone=${activeBalanceZone}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}
export const apiFetchQuantityElements = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tanks/GetTanksSize`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apifetchOriginPlants = async (
  destinationsIds?: number[],
  clientId?: number
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const activeBalanceZone = getActiveBalanceZone()?.id

  const url = '/api/Tanks/FetchOriginPlants'
  let query = '?'

  if (destinationsIds && destinationsIds.length > 0) {
    destinationsIds.forEach((id, idx) => {
      query = query + `DestinationsIds=${id}`
      if (idx !== destinationsIds.length - 1) query = query + '&'
    })
  }

  if (clientId) {
    if (query !== '?') query = query + '&'
    query = query + `SubjectId=${clientId}`
  }

  if (activeBalanceZone) {
    if (query !== '?') query = query + '&'
    query = query + `BalanceZone=${activeBalanceZone}`
  }

  // if (query !== '?') {
  //   query = query + '&'
  // }

  // query = query + 'api-version=1.0'

  return await AxiosInstance.get(`${apiSuffixUrl}${url}${query}`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apifetchDestinations = async (
  relatedDestinationsIds?: number[],
  clientId?: number,
  originPlantId?: number
): Promise<SelectOption[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const activeBalanceZone = getActiveBalanceZone()?.id

  const url = '/api/Tanks/FetchDestinations'
  let query = '?'

  if (relatedDestinationsIds && relatedDestinationsIds.length > 0) {
    relatedDestinationsIds.forEach((id, idx) => {
      query = query + `RelatedDestinationsIds=${id}`
      if (idx !== relatedDestinationsIds.length - 1) query = query + '&'
    })
  }

  if (clientId) {
    if (query !== '?') query = query + '&'
    query = query + `SubjectId=${clientId}`
  }

  if (originPlantId) {
    if (query !== '?') query = query + '&'
    query = query + `OriginPlantId=${originPlantId}`
  }

  if (activeBalanceZone) {
    if (query !== '?') query = query + '&'
    query = query + `BalanceZone=${activeBalanceZone}`
  }

  // if (query !== '?') {
  //   query = query + '&'
  // }

  // query = query + 'api-version=1.0'

  return await AxiosInstance.get(`${apiSuffixUrl}${url}${query}`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apifetchClients = async (): Promise<Array<any>> => {
  const activeBalanceZone = getActiveBalanceZone()?.id
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const idUser = getUserId()

  return await AxiosInstance.get(
    `${apiSuffixUrl}/api/Tanks/FetchClients?balanceZone=${activeBalanceZone}&idUser=${idUser}`
  ).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchCostTypes = async (): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.get(`${apiSuffixUrl}/api/Tanks/FetchTankCostTypes`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiFetchDefaultCosts = async (tripDate?: string): Promise<Array<any>> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const url = '/api/Tanks/FetchTankDefaultCost'
  let query = ''

  if (tripDate)  {
    query = query + `?filterDate=${tripDate}`  
  }
  
  return await AxiosInstance.get(`${apiSuffixUrl}${url}${query}`).then(response => {
    if (response.data.length > 0) {
      return response.data
    } else {
      return []
    }
  })
}

export const apifetchTankTravel = async (tripsIds: number[]): Promise<Tanks[]> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const activeBalanceZone = getActiveBalanceZone()?.id
  const activeCompany = getActiveCompany()?.id!

  const url = '/api/Tanks/FetchTankTravels'
  let query = '?'

  if (tripsIds && tripsIds.length > 0) {
    tripsIds.forEach((id, idx) => {
      query = query + `Ids=${id}`
      if (idx !== tripsIds.length - 1) query = query + '&'
    })
  }

  if (activeBalanceZone) {
    if (query !== '?') query = query + '&'
    query = query + `BalanceZone=${activeBalanceZone}`
  }

  if (activeCompany) {
    if (query !== '?') query = query + '&'
    query = query + `Company=${activeBalanceZone}`
  }

  return await AxiosInstance.get(`${apiSuffixUrl}${url}${query}`).then(response => {
    if (response.data !== undefined) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiTankUpdate = async (tank: any): Promise<boolean> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  return await AxiosInstance.put(`${apiSuffixUrl}/api/Tanks/UpdateTank`, tank).then(res => {
    return true
  })
}

export const apiTankCancel = async (tanksIds: any[]): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.post(`${apiSuffixUrl}/api/Tanks/CancelTanks`, tanksIds).then(res => {
    return true
  })
}

export const postTankSend = async (sendTanks: TankIdValue[]): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)
  const request: MassiveDispatchRequest = {
    companyID: getActiveCompany()?.id,
    dispatchType: EnumDispatchType.Nominacion,
    operations: sendTanks
  }
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Dispatches/MassiveDispatches`, request).then(
    response => {
      return response.data
    }
  )
}

export const apiFetchTankOpsToDispatch = async (tankIds: number[]): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const url = '/api/Tanks/FetchTankOpsToDispatch'
  let tankIdsQuery = ''

  if (tankIds && tankIds.length > 0) {
    tankIds.forEach((id, idx) => {
      tankIdsQuery = tankIdsQuery + `tankIds=${id}`
      if (idx !== tankIds.length - 1) tankIdsQuery = tankIdsQuery + '&'
    })
  } else {
    return []
  }

  return await AxiosInstance.get(
    `${apiSuffixUrl}${url}?companyId=${getActiveCompany()?.id}&balanceZone=${getActiveBalanceZone()
      ?.id!}&${tankIdsQuery}`
  ).then(response => {
    if (response.data !== undefined) {
      return response.data
    } else {
      return []
    }
  })
}

export const apiDeleteTank = async (tankId: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  return await AxiosInstance.delete(
    `${apiSuffixUrl}/api/Tanks/DeleteTank?tankOrderId=${tankId}`
  ).then(res => {
    if (res.data !== undefined) {
      return res.data
    } else {
      return []
    }
  })
}

export const apiOpsInActiveDispatch = async (opsIds: number[]): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer)

  const url = '/api/Dispatches/GetOpsLogInActiveDispatch'
  let opsIdsQuery = ''

  if (opsIds && opsIds.length > 0) {
    opsIds.forEach((id, idx) => {
      opsIdsQuery = opsIdsQuery + `ids=${id}`
      if (idx !== opsIds.length - 1) opsIdsQuery = opsIdsQuery + '&'
    })
  } else {
    return []
  }

  return await AxiosInstance.get(`${apiSuffixUrl}${url}?${opsIdsQuery}`).then(response => {
    if (response.data !== undefined) {
      return response.data
    } else {
      return []
    }
  })
}
